module.exports = __webpack_public_path__ + "static/img/paint.e56cf8ba.png";